import settings from 'src/settings'

// Shared by SignupForm and OtpForm, which both show the legal notice before
// anyone is signed in. One place decides whether there is anything to show, so
// the two screens cannot drift apart.

export const legalUrls = {
  termsUrl: settings.legal.terms,
  salesUrl: settings.legal.sales,
  privacyUrl: settings.legal.privacy,
}

// All three empty means nothing to link to, so nothing is displayed at all —
// neither the sentence nor, on the signup form, the checkbox that goes with it.
export const hasLegalLinks = Object.values(legalUrls).some((url) => !!url)
